import React, { useState, useEffect, useRef } from "react";
import { Drawer, Affix } from "antd";
import qs from "qs";
import { getQuery } from "@/service/http";
import buyDealAPI, { client } from "@/service/buy-deal";
import DealOrder from "./deal-order";
import DealCashier from "./deal-cashier";
import "./index.less";

const isPc = client === "desktop" && window.innerWidth > 1280;

function WalkIn(props) {
  const { deal_id, visible, setVisible } = props;
  const [step, setStep] = useState(0);
  const ref = useRef({});
  const { lang, region } = getQuery();
  const baseUrl = `${document.referrer}${lang}/${region}/deals/${deal_id}/reservation?`;

  function callback(status, orderInfo) {
    ref.current.orderId = orderInfo.uuid;
    setStep(2);
  }

  useEffect(() => {
    const payment =
      getQuery().payment || "";
    const { order_id } = qs.parse(payment, {
      delimiter: "-",
    });
    ref.current.orderId = order_id;
    setStep(order_id ? 2 : 1);
  }, []);

  if (isPc) {
    return (
      <div className="pc-aside" style={{ width: "400px" }}>
        <aside className="page-deal--aside">
          <Affix>
            <div className="buy-deal">
              {step === 1 && (
                <DealCashier
                  showBack={false}
                  baseUrl={baseUrl}
                  onBack={() => setVisible(false)}
                  callback={callback}
                  {...props}
                ></DealCashier>
              )}
              {step === 2 && (
                <DealOrder
                  showBack={true}
                  baseUrl={baseUrl}
                  onBack={() => setStep(1)}
                  orderId={ref.current.orderId}
                  {...props}
                ></DealOrder>
              )}
            </div>
          </Affix>
        </aside>
      </div>
    );
  }

  return (
    <Drawer
      visible={visible}
      closable={false}
      zIndex={1011}
      placement="right"
      className="buy-deal-drawer"
      width={client === "desktop" ? 500 : "100%"}
    >
      <div className="buy-deal">
        {step === 1 && (
          <DealCashier
            showBack={true}
            baseUrl={baseUrl}
            onBack={() => setVisible(false)}
            callback={callback}
            {...props}
          ></DealCashier>
        )}
        {step === 2 && (
          <DealOrder
            showBack={true}
            baseUrl={baseUrl}
            onBack={() => setStep(1)}
            orderId={ref.current.orderId}
            {...props}
          ></DealOrder>
        )}
      </div>
    </Drawer>
  );
}

export default WalkIn;
